package org.lennycodes.hldi.styles

import com.varabyte.kobweb.compose.css.boxShadow
import com.varabyte.kobweb.compose.css.zIndex
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.boxShadow
import com.varabyte.kobweb.compose.ui.modifiers.display
import com.varabyte.kobweb.compose.ui.modifiers.flexDirection
import com.varabyte.kobweb.compose.ui.modifiers.position
import com.varabyte.kobweb.compose.ui.modifiers.zIndex
import com.varabyte.kobweb.silk.style.CssStyle
import org.jetbrains.compose.web.css.DisplayStyle
import org.jetbrains.compose.web.css.FlexDirection
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.backgroundColor
import org.jetbrains.compose.web.css.display
import org.jetbrains.compose.web.css.flexDirection
import org.jetbrains.compose.web.css.px
import org.lennycodes.hldi.constants.HLDITheme

val MobileMenuStyle = CssStyle {
    base {
        Modifier
            .position(Position.Fixed)
            .boxShadow(offsetX = 0.px, offsetY = 4.px, blurRadius = 8.px, color = Color.rgba(0, 0, 0, 0.1f))
            .zIndex(999)
            .display(DisplayStyle.Flex)
            .flexDirection(FlexDirection.Column)
            .backgroundColor(HLDITheme.Colors.white)
    }
}